<template>
  <v-card>
    <v-toolbar
      card
      dense
      color="transparent"
    >
      <v-toolbar-title><h4>{{ $t('Orders') }}</h4></v-toolbar-title>
      <v-spacer />
      <v-btn
        small
        @click="$emit('create-order')">
        {{ $t('Create Order') }}
      </v-btn>
    </v-toolbar>
    <v-divider />
    <v-card-text class="pa-0">
      <template>
        <v-data-table
          :headers="headers"
          :items="items"
          :rows-per-page-text="$t('Rows per page')"
          hide-headers
          item-key="number"
          class="elevation-0 table-striped"
        >
          <template
            v-slot:items="{ item }"
          >
            <tr
              @click="$emit('selected', item)">
              <td>
                <router-link
                  :to="{
                    name: 'single-order',
                    params: { id: item.number }
                  }"
                  class="text-no-wrap"
                >
                  #{{ item.number }}
                </router-link>
              </td>
              <td class="text-xs-left">
                {{ item.order_created_at | timezone }}
              </td>
              <td class="text-xs-left">
                {{ item.total | money }}
              </td>
              <td class="text-xs-left">
                <v-chip
                  :color="item.status | orderStatusColor"
                  label
                  small
                  dark
                >
                  {{ item.status }}
                </v-chip>
              </td>
            </tr>
          </template>
          <template slot="no-data">
            <p class="text-xs-center mt-3">
              {{ $t('No orders yet for this customer') }}
            </p>
          </template>
          <template v-slot:pageText="props">
            <span>{{ $t('{0} - {1} of {2}', [props.pageStart, props.pageStop, props.itemsLength]) }}</span>
          </template>
        </v-data-table>
      </template>
      <v-divider />
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'CustomerOrders',

  props: {
    items: {
      type: Array,
      default: () => []
    }
  },

  compute: {
    headers () {
      return [
        { text: '#', align: 'left', sortable: false, value: 'id' },
        { text: this.$t('Created At'), value: 'created_at' },
        { text: this.$t('Price'), value: 'progress' },
        { text: this.$t('Status'), value: 'status' }
      ]
    }
  }
}
</script>
